var map = {
	"./bolo_nb/1macaxeira.webp": 3586,
	"./bolo_nb/1milho.webp": 2728,
	"./bolo_nb/1pacoca.webp": 728,
	"./bolo_nb/bolobanana.webp": 6510,
	"./bolo_nb/bolobananasemacucar.webp": 8213,
	"./bolo_nb/bololimao.webp": 8506,
	"./bolo_nb/bolomaca.webp": 1735,
	"./bolo_nb/cenoura.webp": 5885,
	"./bolo_nb/chocolate.webp": 5390,
	"./bolo_nb/churros.webp": 739,
	"./bolo_nb/goiabada.webp": 5961,
	"./bolo_nb/laranja.webp": 2266,
	"./bolo_nb/ninho.webp": 5916,
	"./bolo_nb/noiva.webp": 7332,
	"./junino_nb/macaxeira.webp": 779,
	"./junino_nb/milho.webp": 1165,
	"./junino_nb/pacoca.webp": 2546,
	"./natal_nb/natal_1barra.webp": 6708,
	"./natal_nb/natal_1disco.webp": 26,
	"./natal_nb/natal_alema.webp": 5360,
	"./natal_nb/natal_boloreis.webp": 6470,
	"./natal_nb/natal_brigadeiro.webp": 3901,
	"./natal_nb/natal_brownie_morango.webp": 5243,
	"./natal_nb/natal_cafe.webp": 1146,
	"./natal_nb/natal_caramelo.webp": 9574,
	"./natal_nb/natal_cenoura.webp": 3677,
	"./natal_nb/natal_cheesecake.webp": 8533,
	"./natal_nb/natal_cheesecake_goiaba.webp": 9919,
	"./natal_nb/natal_cheesecake_nutella.webp": 5149,
	"./natal_nb/natal_chocolate.webp": 3807,
	"./natal_nb/natal_damasco.webp": 5805,
	"./natal_nb/natal_domino.webp": 4741,
	"./natal_nb/natal_donaana.webp": 2598,
	"./natal_nb/natal_limao.webp": 4473,
	"./natal_nb/natal_menta.webp": 855,
	"./natal_nb/natal_morango.webp": 3750,
	"./natal_nb/natal_mousse_brigadeiro.webp": 9865,
	"./natal_nb/natal_natalino.webp": 9409,
	"./natal_nb/natal_nozes.webp": 5402,
	"./natal_nb/natal_redvelvet.webp": 354,
	"./natal_nb/natal_seducao.webp": 6419,
	"./natal_nb/natal_tentacao.webp": 839,
	"./natal_nb/natal_tropical.webp": 508,
	"./pascoa_nb/pascoa_alema.webp": 4358,
	"./pascoa_nb/pascoa_barra.webp": 2749,
	"./pascoa_nb/pascoa_biscoito.webp": 2926,
	"./pascoa_nb/pascoa_bombom.webp": 4832,
	"./pascoa_nb/pascoa_brigadeiro.webp": 5016,
	"./pascoa_nb/pascoa_brow.webp": 8928,
	"./pascoa_nb/pascoa_brownozes.webp": 6090,
	"./pascoa_nb/pascoa_caixabrow.webp": 9677,
	"./pascoa_nb/pascoa_crocante.webp": 4906,
	"./pascoa_nb/pascoa_domino.webp": 8273,
	"./pascoa_nb/pascoa_lata.webp": 4044,
	"./torta_nb/alema.webp": 8896,
	"./torta_nb/alema_amendoim.webp": 1241,
	"./torta_nb/alema_branca.webp": 3368,
	"./torta_nb/alema_nozes.webp": 1099,
	"./torta_nb/alema_ovomaltine.webp": 5276,
	"./torta_nb/alema_sem_acucar.webp": 8444,
	"./torta_nb/ameixa.webp": 3271,
	"./torta_nb/amendoim_sem_acucar.webp": 4371,
	"./torta_nb/banana.webp": 1811,
	"./torta_nb/banoffee.webp": 3198,
	"./torta_nb/bombonzao.webp": 7941,
	"./torta_nb/brigadeiro.webp": 9483,
	"./torta_nb/brownie.webp": 3118,
	"./torta_nb/brownie_morango.webp": 8024,
	"./torta_nb/cafe.webp": 1228,
	"./torta_nb/caramelo.webp": 9899,
	"./torta_nb/cheesecake.webp": 755,
	"./torta_nb/cheesecake_goiaba.webp": 2783,
	"./torta_nb/cheesecake_nutella.webp": 5403,
	"./torta_nb/cheesecake_sem_acucar.webp": 8767,
	"./torta_nb/chocolatra.webp": 6189,
	"./torta_nb/damasco.webp": 9885,
	"./torta_nb/docedelicia.webp": 9400,
	"./torta_nb/domino.webp": 1949,
	"./torta_nb/donaana.webp": 3913,
	"./torta_nb/feitico.webp": 6615,
	"./torta_nb/gabriela.webp": 5062,
	"./torta_nb/limao.webp": 7285,
	"./torta_nb/maca.webp": 902,
	"./torta_nb/maracuja.webp": 4624,
	"./torta_nb/menta.webp": 2504,
	"./torta_nb/mesclada.webp": 1994,
	"./torta_nb/morango.webp": 6578,
	"./torta_nb/mousse.webp": 3690,
	"./torta_nb/mousse_brigadeiro.webp": 4034,
	"./torta_nb/mousse_sem_acucar.webp": 3263,
	"./torta_nb/nozes.webp": 1853,
	"./torta_nb/paodemel.webp": 9877,
	"./torta_nb/pontanegra.webp": 6215,
	"./torta_nb/profiterolis.webp": 8856,
	"./torta_nb/redvelvet.webp": 7497,
	"./torta_nb/romeu.webp": 4101,
	"./torta_nb/seducao.webp": 2232,
	"./torta_nb/spumone.webp": 3562,
	"./torta_nb/tentacao.webp": 6566,
	"./torta_nb/tropical.webp": 9982
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2146;